// Mobile navigation toggle
(function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
})();

// Header shadow once the page is scrolled
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;
  function update() {
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', update, { passive: true });
  update();
})();

// Scroll progress bar (visual enhancement only)
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var bar = document.createElement('div');
  bar.className = 'scroll-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  function update() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - doc.clientHeight;
    bar.style.width = (max > 0 ? (doc.scrollTop / max) * 100 : 0) + '%';
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();

// Scroll reveal — progressive enhancement only.
// Elements are visible by default; CSS nudges them 16px down only when
// <html> has the "js" class, and this script releases them based on
// scroll position. Sibling reveals get a small stagger via --reveal-delay.
(function () {
  var items = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
  if (!items.length) return;

  // Assign stagger delays per parent group
  var groups = new Map();
  items.forEach(function (el) {
    var parent = el.parentElement;
    var index = groups.get(parent) || 0;
    groups.set(parent, index + 1);
    el.style.setProperty('--reveal-delay', Math.min(index, 5) * 70 + 'ms');
  });

  var pending = false;

  function inView(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.92 && rect.bottom > 0;
  }

  // After the entrance animation has had time to play, pin the element to
  // its final resting state. In healthy browsers this is a no-op; in
  // environments that freeze animation frames it guarantees correct layout.
  // The transition is suspended for the reset so it applies instantly,
  // then restored so hover effects keep animating.
  function pin(el) {
    el.style.animation = 'none';
    el.style.transform = 'none';
    // Transform stays untransitioned so the reset applies instantly and can
    // never be captured by a stalled transition; the decorative properties
    // keep their smooth hover behavior.
    el.style.transition = 'box-shadow 200ms ease, border-color 200ms ease, background-color 200ms ease, color 200ms ease';
  }

  function settle(el) {
    var delay = parseInt(el.style.getPropertyValue('--reveal-delay'), 10) || 0;
    setTimeout(function () { pin(el); }, 700 + delay);
  }

  function check() {
    pending = false;
    items = items.filter(function (el) {
      if (inView(el)) {
        el.classList.add('is-visible');
        settle(el);
        return false;
      }
      return true;
    });
    if (!items.length) {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
    }
  }

  function schedule() {
    if (!pending) {
      pending = true;
      window.requestAnimationFrame(check);
    }
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  check();

  // Absolute safety net: whatever happens, nothing stays offset.
  setTimeout(function () {
    items.forEach(function (el) {
      el.classList.add('is-visible');
      pin(el);
    });
    items = [];
  }, 4000);
})();

// Same settling guarantee for the hero/page-hero entrance animations.
(function () {
  var animated = document.querySelectorAll(
    '.hero .eyebrow, .hero h1, .hero__inner > p, .hero__actions, .hero__points, .page-hero h1, .page-hero p'
  );
  if (!animated.length) return;
  setTimeout(function () {
    animated.forEach(function (el) {
      el.style.animation = 'none';
      el.style.transform = 'none';
    });
  }, 1600);
})();

// Stat counter count-up. The final value is already in the HTML, so if
// anything fails the correct number is simply shown; a timeout also
// force-restores the exact original text.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var stats = document.querySelectorAll('.stat__value');
  if (!stats.length) return;

  stats.forEach(function (el) {
    var original = el.textContent.trim();
    var match = original.match(/^([^\d]*)([\d.,]+)(.*)$/);
    if (!match) return;
    var target = parseFloat(match[2].replace(/,/g, ''));
    if (!isFinite(target)) return;
    var decimals = (match[2].split('.')[1] || '').length;
    var started = false;

    function format(value) {
      var text = value.toFixed(decimals);
      if (match[2].indexOf(',') !== -1) {
        text = text.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      return match[1] + text + match[3];
    }

    function run() {
      if (started) return;
      started = true;
      var start = null;
      var duration = 1300;
      function frame(now) {
        if (start === null) start = now;
        var progress = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = format(target * eased);
        if (progress < 1) window.requestAnimationFrame(frame);
        else el.textContent = original;
      }
      window.requestAnimationFrame(frame);
      // Safety: exact original text no matter what
      setTimeout(function () { el.textContent = original; }, duration + 500);
    }

    function checkStart() {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        run();
        window.removeEventListener('scroll', checkStart);
      }
    }
    window.addEventListener('scroll', checkStart, { passive: true });
    checkStart();
    setTimeout(run, 3000);
  });
})();
